<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (mousedown)="windowClick()">
  <dialog-header [label]="'MENUBAR.SENSORWINDOW' | translate" [dialogRef]='dialogRef' [object]='this'>
  </dialog-header>

  <div fxLayout="row" fxLayoutAlign="center center" style="padding-right: 10px; padding-left: 12px;">
    <mat-form-field class="mat-form-field" fxLayout="column" fxLayoutAlign="center center"
      style="margin-top: 10px; min-width: 577px;">
      <input matInput type="text" [placeholder]="'ACTIONS.SEARCH' | translate" class="field-input"
        (input)="onSearchChange()" autocomplete="off" [(ngModel)]="SearchResults">
    </mat-form-field>
    <button class="small-button" mat-stroked-button (click)="sensorWindowClicked()"
      [matTooltip]="'ACTIONS.HOOK' | translate">
      <mat-icon class="svg-icon">add</mat-icon>
    </button>
  </div>

  <div fxLayout="column" style="overflow-y: auto; max-height: 300px;">
    <div  *ngFor = " let sns of FilteredSensors; let i = index" fxLayout="row" fxLayoutAlign="space-between center" class="sensor-row" >     
      <acoustic-snippet *ngIf="sns.isAcoustic" [sensor]="sns"> </acoustic-snippet>
      <sensor-snippet *ngIf="sns.isRadar" [sensor]="sns"> </sensor-snippet>
      <video-snippet *ngIf="sns.isVideo" [sensor]="sns"> </video-snippet>

      <!-- <div style="margin-top: 5px; margin-bottom: 5px;"></div> -->
    </div>
  </div>
  
</div>